export default "__VITE_ASSET__BqPT8W_q__"